export const MODULES = [
  'ACTIVITY_LOG',
  'ACCOUNTING',
  'BILLING',
  'CUSTOMERS',
  'DASHBOARD',
  'INCIDENCES',
  'NOTIFICATIONS',
  'OPERATIONS',
  'PAYMENTS',
  'PRODUCTS',
  'REPORTS',
  'ROLES',
  'SERVICES',
  'SETTINGS',
  'STOCK',
  'USERS',
] as const;

export type AppModule = (typeof MODULES)[number];
